var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 4
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23078 3.49998C1.81829 3.49998 1.46518 3.3531 1.17143 3.05935C0.877692 2.7656 0.730825 2.41248 0.730825 2C0.730825 1.58752 0.877692 1.2344 1.17143 0.94065C1.46518 0.6469 1.81829 0.500025 2.23078 0.500025C2.64328 0.500025 2.99639 0.6469 3.29013 0.94065C3.58388 1.2344 3.73075 1.58752 3.73075 2C3.73075 2.41248 3.58388 2.7656 3.29013 3.05935C2.99639 3.3531 2.64328 3.49998 2.23078 3.49998ZM8 3.49998C7.58752 3.49998 7.2344 3.3531 6.94065 3.05935C6.6469 2.7656 6.50003 2.41248 6.50003 2C6.50003 1.58752 6.6469 1.2344 6.94065 0.94065C7.2344 0.6469 7.58752 0.500025 8 0.500025C8.41248 0.500025 8.7656 0.6469 9.05935 0.94065C9.3531 1.2344 9.49998 1.58752 9.49998 2C9.49998 2.41248 9.3531 2.7656 9.05935 3.05935C8.7656 3.3531 8.41248 3.49998 8 3.49998ZM13.7692 3.49998C13.3567 3.49998 13.0036 3.3531 12.7099 3.05935C12.4161 2.7656 12.2693 2.41248 12.2693 2C12.2693 1.58752 12.4161 1.2344 12.7099 0.94065C13.0036 0.6469 13.3567 0.500025 13.7692 0.500025C14.1817 0.500025 14.5348 0.6469 14.8286 0.94065C15.1223 1.2344 15.2692 1.58752 15.2692 2C15.2692 2.41248 15.1223 2.7656 14.8286 3.05935C14.5348 3.3531 14.1817 3.49998 13.7692 3.49998Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.be7f1a25f09e5e468fca09510e04584f.svg";
export { ForwardRef as ReactComponent };